// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3CTCe","selected":"Chip_selected__2B3Qp"};